import { z } from 'zod';
import { ProblemError } from '../common/problem.js';
export const PORT_NAMES = [
    'CreditCorePort',
    'DepositCorePort',
    'BreBPort',
    'CreditBureauPort',
    'KycPort',
    'ESignaturePort',
    'NotificationPort',
    'SpeechPort',
    'LlmPort',
    'BlobStoragePort',
];
export const ExternalCallOutcomeSchema = z.enum(['OK', 'REJECTED', 'TIMEOUT', 'ERROR']);
/** Error de puerto con código Paguz normalizado. */
export class PortError extends ProblemError {
    port;
    operation;
    outcome;
    externalCode;
    constructor(reasonCode, options) {
        super(reasonCode, options);
        this.name = 'PortError';
        this.port = options.port;
        this.operation = options.operation;
        this.outcome = options.outcome;
        this.externalCode = options.externalCode;
    }
    /** Timeout / 5xx: no se sabe si el sistema externo aplicó la operación. */
    get isOutcomeUnknown() {
        return this.outcome === 'TIMEOUT' || this.outcome === 'ERROR';
    }
}
export function isPortError(error) {
    return error instanceof PortError;
}
//# sourceMappingURL=common.js.map